import React from "react";
import { motion } from "framer-motion";

// Scroll-triggered fade-up reveal used across sections.
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, scale: 0.98 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Section label ("WHAT WE DO" style eyebrow).
export const Eyebrow = ({ children, color = "#53C653" }) => (
  <span
    className="text-sm tracking-[0.25em] uppercase font-semibold font-heading"
    style={{ color }}
  >
    {children}
  </span>
);

export default Reveal;
